

import { MessageSquareText } from "lucide-react";
import { FloatingButton } from "@/components/custom/FloatingButton.jsx";

const DiscordButton = () => {
  return (
    <FloatingButton
      asChild
      className="z-60"
    >
      <a href="https://discord.com/invite/73WrkDWEE2" target="_blank" rel="noopener noreferrer">
        <MessageSquareText className="size-6 md:size-10" />
      </a>
    </FloatingButton>
  );
};

export default DiscordButton;
